module.exports = __webpack_public_path__ + "assets/img/img-number-01.b6fbea70.svg";